
<template>
    <div class="c-text-section section o-section__max-w">
        <h1>TERMS & CONDITIONS</h1>
        <p class="c-text-section--no-border">Artful Dodgers is 100% New Zealand owned and operated.</p>
        
        <p class="c-text-section--no-border">These terms and conditions may be updated every now and again. These Terms & Conditions are current as of July 2021. By using our site you acknowledge and agree to these terms and conditions. Further, by continuing, you acknowledge that you have read, understood and accepted these Terms and Conditions. When purchasing a product from this website you agree to be bound by these Terms and Conditions.</p>
        
        <h2>GOVERNING LAW</h2>
        <p>The laws of New Zealand govern any contract arising out of this website, and all disclaimers, terms and conditions and terms of use.</p>
        
        <h2>COLOURS & FINISHES</h2>
        <p>Artful Dodgers has tried to be as accurate as possible in describing, detailing and displaying the products for sale. However due to the variety of web browsers, devices and screen configurations, colours and finishes may vary.</p>
        
        <h2>PRICING</h2>
        <p>All prices include GST (which is currently 15% sales tax - if the GST rate changes we reserve the right to immediately amend our prices accordingly). All prices are correct at time of publication, however we reserve the right to alter prices for any reason. Artful Dodgers Ltd is not responsible for any extra charges due to customs, VAT or import tax.</p>
        
        <h2>COPYRIGHT</h2>
        <p>All products, designs and images on this website are protected by copyright and owned by the Artful Dodgers.</p>
        
        <h2>SHIPPING ISSUES</h2>
        <p>Artful Dodgers will ensure that your purchase has been  immaculately packaged and dispatched. However Artful Dodgers is not responsible to the buyer for any loss of items or damage caused in transit or items that are accepted by a third party or stolen.</p>
        <h2>SHIPPING & RETURNS</h2>
        <p>As described in the shipping and returns <router-link to="/shippingandreturns">section of our website.</router-link> These are part of our Terms & Conditions.</p>
        <h2>HELP</h2>
        <p>If at any time you are unsatisfied, confused, frustrated or lonely please give us a call or send us an email and we’ll reply as quickly as we can. Love and compassion.</p>

        <a class="c-btn c-btn__link c-btn__link--back" @click="$router.go(-1)">Go back</a>
    </div>
</template>

<script>
    export default {
        metaInfo: {
            title: 'Terms & Conditions',
            meta: [
                { name: 'description', content: 'The Artful Dodgers Ltd Ring. Terms & Conditions'},
                { property: 'og:title', content: 'Terms & Conditions | Artful Dodgers Ltd'},
                { property: 'og:site_name', content: 'Artful Dodgers'},
                { property: 'og:description', content: 'The Artful Dodgers Ltd. Treat yourself!'},
                { property: 'og:type', content: 'terms'},
                { property: 'og:url', content: 'https://artfuldodgers.co.nz/termsandconditions'},
                { property: 'og:image', content: 'https://artfuldodgers.co.nz/assets/img/ad-trixy-ring.png'}
            ]
        },
        data: function() {
            return {
            }
        },
        methods: {
        },
    }
</script>




// WEBPACK FOOTER //
// TermsAndConditions.vue?51dc3efe